import React from 'react';
import { observer } from 'mobx-react-lite';
import { consentStore } from './consentStore';
import { CookieIcon } from './CookieIcon';
import './consent.css';

/** Always-visible way to change or withdraw consent (PTS). */
export const ReopenButton = observer(() => {
  const s = consentStore;
  if (!s.uiVisible || s.dialogOpen) return null;
  const label = s.t('ReopenButton');
  return (
    <button type="button" className={`cc-reopen cc-reopen-${s.config.iconPosition}`} aria-label={label} title={label} onClick={() => s.openDialog()}>
      <CookieIcon size={24} />
    </button>
  );
});

export default ReopenButton;
